// src/components/Accounts.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SvgAccount = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: "4",
          y: "3",
          width: "16",
          height: "18",
          fill: "white",
          stroke: "black",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: "10",
          y: "7",
          width: "6",
          height: "4",
          rx: "1",
          fill: "#ECC57C",
          stroke: "black",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ jsx("line", { x1: "6.5", y1: "3", x2: "6.5", y2: "21", stroke: "black" }),
      /* @__PURE__ */ jsx("line", { x1: "10", y1: "17.5", x2: "16", y2: "17.5", stroke: "black" })
    ]
  }
);
var Accounts_default = SvgAccount;

// src/components/ApiDeveloper.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgApiDeveloper = (props) => /* @__PURE__ */ jsxs2(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx2("rect", { x: "2", y: "8", width: "20", height: "13", fill: "white", stroke: "black" }),
      /* @__PURE__ */ jsx2("path", { d: "M6 12L8.5 14.5L6 17M10 17H14", stroke: "black" }),
      /* @__PURE__ */ jsx2(
        "path",
        {
          d: "M2 5C2 4.05719 2 3.58579 2.29289 3.29289C2.58579 3 3.05719 3 4 3H20C20.9428 3 21.4142 3 21.7071 3.29289C22 3.58579 22 4.05719 22 5V8H2V5Z",
          fill: "#ECC57C",
          stroke: "black"
        }
      ),
      /* @__PURE__ */ jsx2("path", { d: "M4 5.5H5M6.5 5.5H7.5", stroke: "black" })
    ]
  }
);
var ApiDeveloper_default = SvgApiDeveloper;

// src/components/ApiDocs.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var SvgApiDocs = (props) => /* @__PURE__ */ jsx3("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx3("g", { id: "API Docs", children: /* @__PURE__ */ jsx3("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M4.40272 3.69134C5.34586 3.50427 6.29545 3.40906 7 3.40906C7.70455 3.40906 8.65414 3.50427 9.59728 3.69134C10.4359 3.85769 11.3031 4.10316 12 4.43846C12.6969 4.10316 13.5641 3.85769 14.4027 3.69134C15.3459 3.50427 16.2955 3.40906 17 3.40906C17.7045 3.40906 18.6541 3.50427 19.5973 3.69134C20.535 3.87733 21.5083 4.16224 22.2394 4.56102L22.5 4.70315V19.809L21.7764 19.4472C21.1715 19.1447 20.3083 18.9051 19.4106 18.7419C18.5184 18.5797 17.632 18.5 17 18.5C16.368 18.5 15.4816 18.5797 14.5894 18.7419C13.6917 18.9051 12.8285 19.1447 12.2236 19.4472L12 19.559L11.7764 19.4472C11.1715 19.1447 10.3083 18.9051 9.41056 18.7419C8.51838 18.5797 7.63197 18.5 7 18.5C6.36803 18.5 5.48162 18.5797 4.58944 18.7419C3.69169 18.9051 2.82849 19.1447 2.22361 19.4472L1.5 19.809V4.70315L1.76057 4.56102C2.49167 4.16224 3.46502 3.87733 4.40272 3.69134ZM11.5 5.30818C10.9228 5.04081 10.176 4.82562 9.40272 4.67223C8.51253 4.49566 7.62879 4.40906 7 4.40906C6.37121 4.40906 5.48747 4.49566 4.59728 4.67223C3.82395 4.82562 3.0772 5.04081 2.5 5.30818V18.249C3.0915 18.0385 3.7594 17.8764 4.41056 17.758C5.35171 17.5869 6.29863 17.5 7 17.5C7.70137 17.5 8.64829 17.5869 9.58944 17.758C10.2406 17.8764 10.9085 18.0385 11.5 18.249V5.30818ZM12.5 18.249C13.0915 18.0385 13.7594 17.8764 14.4106 17.758C15.3517 17.5869 16.2986 17.5 17 17.5C17.7014 17.5 18.6483 17.5869 19.5894 17.758C20.2406 17.8764 20.9085 18.0385 21.5 18.249V5.30818C20.9228 5.04081 20.176 4.82562 19.4027 4.67223C18.5125 4.49566 17.6288 4.40906 17 4.40906C16.3712 4.40906 15.4875 4.49566 14.5973 4.67223C13.824 4.82562 13.0772 5.04081 12.5 5.30818V18.249ZM19 7.49997V8.49997H15V7.49997H19ZM19 10.5V11.5H15V10.5H19ZM18 14.5H15V13.5H18V14.5Z", fill: "black" }) }) });
var ApiDocs_default = SvgApiDocs;

// src/components/ApiReference.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgApiReference = (props) => /* @__PURE__ */ jsx4(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxs3("g", { id: "API Reference", children: [
      /* @__PURE__ */ jsx4(
        "path",
        {
          id: "Vector",
          d: "M4 3V2.5H3.5V3H4ZM4 21H3.5V21.5H4V21ZM12.1429 8L12.484 8.36553L12.8757 8L12.484 7.63447L12.1429 8ZM4 3.5H18V2.5H4V3.5ZM19.5 5V19H20.5V5H19.5ZM18 20.5H4V21.5H18V20.5ZM4.5 21V3H3.5V21H4.5ZM19.5 19C19.5 19.4855 19.4989 19.7994 19.4678 20.0306C19.4387 20.2475 19.3916 20.3155 19.3536 20.3536L20.0607 21.0607C20.3155 20.8058 20.4149 20.4917 20.4589 20.1639C20.5011 19.8505 20.5 19.4573 20.5 19H19.5ZM18 21.5C18.4573 21.5 18.8505 21.5011 19.1639 21.4589C19.4917 21.4149 19.8058 21.3155 20.0607 21.0607L19.3536 20.3536C19.3155 20.3916 19.2475 20.4387 19.0306 20.4678C18.7994 20.4989 18.4855 20.5 18 20.5V21.5ZM18 3.5C18.4855 3.5 18.7994 3.50106 19.0306 3.53215C19.2475 3.56131 19.3155 3.60838 19.3536 3.64645L20.0607 2.93934C19.8058 2.68451 19.4917 2.58514 19.1639 2.54107C18.8505 2.49894 18.4573 2.5 18 2.5V3.5ZM20.5 5C20.5 4.54273 20.5011 4.14948 20.4589 3.8361C20.4149 3.50835 20.3155 3.19417 20.0607 2.93934L19.3536 3.64645C19.3916 3.68451 19.4387 3.75248 19.4678 3.96935C19.4989 4.20061 19.5 4.51446 19.5 5H20.5ZM10 14.5H16V13.5H10V14.5ZM10 17.5H16V16.5H10V17.5ZM9.65884 6.36553L11.8017 8.36553L12.484 7.63447L10.3412 5.63447L9.65884 6.36553ZM11.8017 7.63447L9.65884 9.63447L10.3412 10.3655L12.484 8.36553L11.8017 7.63447ZM13.4286 10.5H16V9.5H13.4286V10.5Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx4("rect", { id: "Color", x: "4", y: "3", width: "3", height: "18", fill: "#ECC57C", stroke: "black" })
    ] })
  }
);
var ApiReference_default = SvgApiReference;

// src/components/Compliance.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgCompliance = (props) => /* @__PURE__ */ jsxs4(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx5(
        "path",
        {
          fill: "#fff",
          d: "M4.68 15.56c-1.973-3.334-1.662-9.722-1.662-9.722L10.5 3l7.482 2.838s.31 6.388-1.662 9.723C14.746 18.219 10.5 21 10.5 21s-4.246-2.78-5.82-5.44Z"
        }
      ),
      /* @__PURE__ */ jsx5(
        "path",
        {
          stroke: "#000",
          d: "M5.428 7.459c.002 1.519.15 4.86 1.319 6.836.718 1.215 2.148 2.461 3.217 3.292M3.018 5.838s-.31 6.388 1.663 9.723C6.254 18.219 10.5 21 10.5 21s4.246-2.78 5.82-5.44c1.973-3.334 1.662-9.722 1.662-9.722L10.5 3 3.018 5.838Z"
        }
      ),
      /* @__PURE__ */ jsx5(
        "circle",
        {
          cx: 17.5,
          cy: 17.5,
          r: 5.5,
          fill: "#ECC57C",
          stroke: "#000",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx5("path", { stroke: "#000", d: "m15.268 17.701 1.775 1.968 2.725-4.169" })
    ]
  }
);
var Compliance_default = SvgCompliance;

// src/components/Error.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var SvgError = (props) => /* @__PURE__ */ jsx6(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        fill: "#000",
        d: "M22 30h4v4h-4zm0-16h4v12h-4zm1.98-10C12.94 4 4 12.96 4 24s8.94 20 19.98 20C35.04 44 44 35.04 44 24S35.04 4 23.98 4M24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16"
      }
    )
  }
);
var Error_default = SvgError;

// src/components/Entities.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgEntities = (props) => /* @__PURE__ */ jsxs5(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M19.6369 20.5L20 16.6667C19.0359 14.8235 15.5069 14.5623 13.919 15.8543L13.479 20.5L19.6369 20.5Z",
          fill: "#ECC57C"
        }
      ),
      /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M13.479 20.5L19.6369 20.5M13.479 20.5L13.919 15.8543C15.5069 14.5623 19.0359 14.8235 20 16.6667L19.6369 20.5M13.479 20.5H2.5M19.6369 20.5H22",
          stroke: "black"
        }
      ),
      /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M5.47906 20.5L5 15.0332C6.62953 11.9191 12.371 11.8856 14 15L13.9191 15.8543L13.479 20.5L5.47906 20.5Z",
          fill: "white",
          stroke: "black"
        }
      ),
      /* @__PURE__ */ jsx7("circle", { cx: "9.5", cy: "6.5", r: "3.5", fill: "white", stroke: "black" }),
      /* @__PURE__ */ jsx7("circle", { cx: "16.5", cy: "10.5", r: "2.5", fill: "#ECC57C", stroke: "black" })
    ]
  }
);
var Entities_default = SvgEntities;

// src/components/Feedback.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgFeedback = (props) => /* @__PURE__ */ jsxs6(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx8(
        "path",
        {
          fill: "#fff",
          d: "M12 4C8.686 4 6 6.6 6 9.806c0 2.256 1.33 4.211 3.273 5.172.818.405 1.09 2.458 1.09 2.458h3.273s.273-2.053 1.091-2.458C16.67 14.018 18 12.062 18 9.806 18 6.599 15.314 4 12 4Z"
        }
      ),
      /* @__PURE__ */ jsx8(
        "path",
        {
          stroke: "#000",
          d: "m9.818 9.806 1.937 2.076 2.972-4.4M18 9.806C18 6.599 15.314 4 12 4S6 6.6 6 9.806c0 2.256 1.33 4.211 3.273 5.172.818.405 1.09 2.458 1.09 2.458h3.273s.273-2.053 1.091-2.458C16.67 14.018 18 12.062 18 9.806Z"
        }
      ),
      /* @__PURE__ */ jsx8(
        "path",
        {
          fill: "#ECC57C",
          stroke: "#000",
          d: "M10.364 19.305h3.272v2.64L12 23l-1.636-1.056v-2.639Z"
        }
      ),
      /* @__PURE__ */ jsx8(
        "path",
        {
          fill: "#000",
          d: "M4.76 6.274 3 5.295l.53-.885 1.763.978a7.688 7.688 0 0 0-.533.886ZM4.76 13.136 3 14.115l.53.885 1.763-.978a7.69 7.69 0 0 1-.533-.886ZM18.707 14.022 20.47 15l.531-.885-1.76-.979a7.68 7.68 0 0 1-.533.886ZM19.24 6.274 21 5.295l-.53-.885-1.763.978c.197.283.375.579.533.886ZM12.532 1.958 12.53 0 11.469 0l-.001 1.958a8.51 8.51 0 0 1 1.064 0Z"
        }
      )
    ]
  }
);
var Feedback_default = SvgFeedback;

// src/components/Guides.tsx
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgGuides = (props) => /* @__PURE__ */ jsx9(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxs7("g", { id: "Icon", children: [
      /* @__PURE__ */ jsxs7("g", { id: "Vector", children: [
        /* @__PURE__ */ jsx9(
          "path",
          {
            d: "M22 6C20.6667 5.27272 18.3333 4.90909 17 4.90909C15.6667 4.90909 13.3333 5.27272 12 6V20C13.3333 19.3333 15.6667 19 17 19C18.3333 19 20.6667 19.3333 22 20V6ZM12 6C10.6667 5.27272 8.33333 4.90909 7 4.90909C5.66667 4.90909 3.33333 5.27272 2 6V20C3.33333 19.3333 5.66667 19 7 19C8.33333 19 10.6667 19.3333 12 20V6Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx9(
          "path",
          {
            d: "M12 6C13.3333 5.27272 15.6667 4.90909 17 4.90909C18.3333 4.90909 20.6667 5.27272 22 6V20C20.6667 19.3333 18.3333 19 17 19C15.6667 19 13.3333 19.3333 12 20M12 6V20M12 6C10.6667 5.27272 8.33333 4.90909 7 4.90909C5.66667 4.90909 3.33333 5.27272 2 6V20C3.33333 19.3333 5.66667 19 7 19C8.33333 19 10.6667 19.3333 12 20",
            stroke: "black"
          }
        )
      ] }),
      /* @__PURE__ */ jsx9("path", { id: "Vector 28", d: "M5 9H9M5 12H9M5 15H7.4", stroke: "black" }),
      /* @__PURE__ */ jsx9(
        "path",
        {
          id: "Vector 27",
          d: "M18 4H16C15.4477 4 15 4.44772 15 5V11L17 9L19 11V5C19 4.44772 18.5523 4 18 4Z",
          fill: "#ECC57C",
          stroke: "black"
        }
      )
    ] })
  }
);
var Guides_default = SvgGuides;

// src/components/Home.tsx
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgHome = (props) => /* @__PURE__ */ jsxs8(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx10("path", { fill: "#fff", stroke: "#000", strokeLinecap: "round", d: "m20 9-7.5-6L5 9v11h15V9Z" }),
      /* @__PURE__ */ jsx10("path", { stroke: "#000", strokeLinecap: "round", d: "M11 16H8v4m3-4v4m0-4v-2h3" }),
      /* @__PURE__ */ jsx10("path", { fill: "#ECC57C", stroke: "#000", strokeLinecap: "round", d: "M14 20h3v-8h-3v8Z" })
    ]
  }
);
var Home_default = SvgHome;

// src/components/Lock.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var SvgLock = (props) => /* @__PURE__ */ jsx11(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx11(
      "path",
      {
        fill: "#000",
        d: "M36 16h-2v-4c0-5.52-4.48-10-10-10S14 6.48 14 12v4h-2c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V20c0-2.2-1.8-4-4-4M24 34c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4m6.2-18H17.8v-4c0-3.42 2.78-6.2 6.2-6.2s6.2 2.78 6.2 6.2z"
      }
    )
  }
);
var Lock_default = SvgLock;

// src/components/Logo.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var SvgLogo = (props) => /* @__PURE__ */ jsx12("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 487 103", ...props, children: /* @__PURE__ */ jsx12("g", { fill: "#000", fillRule: "nonzero", children: /* @__PURE__ */ jsx12("path", { d: "M310.93 63.46h24.69v3h-21.34v14.43h20.24V84h-20.24v15.62h22.93l-1.41 3.08h-24.87zM147 63.46h12.64a22.7 22.7 0 0 1 7 .91 11 11 0 0 1 4.36 2.44 8.35 8.35 0 0 1 2.17 3.61 15.54 15.54 0 0 1 .6 4.37 16.74 16.74 0 0 1-.63 4.62 9 9 0 0 1-2.23 3.84 11 11 0 0 1-4.34 2.62 21.7 21.7 0 0 1-7 1h-9.24v15.89H147v-39.3Zm12.59 20.45a19.14 19.14 0 0 0 5.39-.63 8 8 0 0 0 3.29-1.79 5.84 5.84 0 0 0 1.65-2.8c.312-1.222.46-2.48.44-3.74a12.87 12.87 0 0 0-.49-3.79 5.72 5.72 0 0 0-1.73-2.67 8.08 8.08 0 0 0-3.33-1.59 22.1 22.1 0 0 0-5.28-.53h-9.24v17.54h9.3ZM233.84 63.46h3.35v39.26h-3.35zM255.53 63.46h4.34l14.19 35.35 14.41-35.35h4.12v39.26h-3.14V69.07c-.18.33-.76 1.74-1.75 4.23-.44 1.07-1 2.41-1.65 4-.65 1.59-1.48 3.63-2.45 6-.97 2.37-2.12 5.14-3.44 8.33-1.32 3.19-2.84 6.87-4.56 11h-3.19l-13.75-33.34v33.43h-3.13V63.46ZM156.84 6.19H143.2V3.11h30.57v3.08h-13.58v36.17h-3.35zM327.12 32.08a9.45 9.45 0 0 0 3.79 6.35c1.95 1.31 4.84 2 8.69 2a15.57 15.57 0 0 0 4.92-.66 8.35 8.35 0 0 0 3.11-1.77 6.31 6.31 0 0 0 1.65-2.59 9.82 9.82 0 0 0 .49-3.13 11 11 0 0 0-.3-2.61 5.58 5.58 0 0 0-1.15-2.26 7.23 7.23 0 0 0-2.45-1.78 15.53 15.53 0 0 0-4.18-1.21l-4.89-.83a33.21 33.21 0 0 1-5.09-1.26 12.65 12.65 0 0 1-3.76-2 7.87 7.87 0 0 1-2.34-3.11 11.6 11.6 0 0 1-.8-4.56A9.25 9.25 0 0 1 325.94 8a9.87 9.87 0 0 1 3-3.28c1.36-.9 2.87-1.55 4.46-1.92a22.53 22.53 0 0 1 5.41-.63 20.41 20.41 0 0 1 6.16.79A12.39 12.39 0 0 1 349.06 5a9.72 9.72 0 0 1 2.47 3 17.94 17.94 0 0 1 1.38 3.38l-3.08.88a17.93 17.93 0 0 0-1.29-3.05 7.23 7.23 0 0 0-2-2.28 8.77 8.77 0 0 0-3.11-1.43 18.08 18.08 0 0 0-4.56-.5 18.58 18.58 0 0 0-5.06.58 9.23 9.23 0 0 0-3.3 1.59 5.91 5.91 0 0 0-1.82 2.42 8.32 8.32 0 0 0-.55 3 9.37 9.37 0 0 0 .39 2.86 5 5 0 0 0 1.32 2.09 7.66 7.66 0 0 0 2.5 1.48 22.81 22.81 0 0 0 3.93 1.05l5.56 1a26.06 26.06 0 0 1 5.16 1.45 11.64 11.64 0 0 1 3.6 2.22 8.21 8.21 0 0 1 2.11 3.26 12.7 12.7 0 0 1 .69 4.4 10.45 10.45 0 0 1-.88 4.26 9.52 9.52 0 0 1-2.61 3.49 12.75 12.75 0 0 1-4.32 2.36 18.62 18.62 0 0 1-6 .88 27.38 27.38 0 0 1-5.91-.6 14.28 14.28 0 0 1-4.79-2 11.05 11.05 0 0 1-3.38-3.49 12.36 12.36 0 0 1-1.65-5.23l3.26.01ZM369 3.11h3.35V27c0 4.44.863 7.773 2.59 10 1.727 2.227 4.567 3.347 8.52 3.36a13.37 13.37 0 0 0 5.09-.86 7.93 7.93 0 0 0 3.35-2.5 10.74 10.74 0 0 0 1.87-4.17 26.36 26.36 0 0 0 .58-5.81V3.11h3.35V27a25.39 25.39 0 0 1-1 7.45 13 13 0 0 1-2.81 5.09 11 11 0 0 1-4.51 2.91 18.16 18.16 0 0 1-6 .93 18.58 18.58 0 0 1-6.13-.93 10.86 10.86 0 0 1-4.51-2.94 13.27 13.27 0 0 1-2.8-5.17 26.23 26.23 0 0 1-1-7.56L369 3.11ZM469.11 25.38 455.36 3.11h4l11.49 19.41 11.71-19.41H486l-13.54 22.27v17h-3.35zM305.75 31.29l-1.42-3.12-10.75-23.6-1.84-4-1.84 4-10.75 23.6-1.42 3.12-5 11.07h3.68l5-11.07h20.66l5 11.07h3.69l-5.01-11.07Zm-22.91-3.12 8.9-20.39 8.91 20.39h-17.81ZM233.84 3.11h24.68v3h-21.33v14.43h20.23v3.13h-20.23v15.62h22.92l-1.4 3.07h-24.87zM217.52 102.72l-8.59-15.84s-.37-.64-.84-1.42c.28-.08.59-.15.85-.24a11.1 11.1 0 0 0 4.35-2.53 8.79 8.79 0 0 0 2.22-3.69 15.82 15.82 0 0 0 .64-4.49 14.68 14.68 0 0 0-.61-4.24 8 8 0 0 0-2.17-3.5 11 11 0 0 0-4.32-2.38 23.4 23.4 0 0 0-7-.88h-12.68v39.26h3.3V86.16h12.05l8.87 16.56h3.93Zm-24.85-19.48V66.38h9.23a23.38 23.38 0 0 1 5.28.5 8.05 8.05 0 0 1 3.33 1.54 5.45 5.45 0 0 1 1.73 2.58 11.9 11.9 0 0 1 .5 3.64 13.65 13.65 0 0 1-.44 3.6 5.75 5.75 0 0 1-1.65 2.69 8.3 8.3 0 0 1-3.3 1.72 20 20 0 0 1-5.39.61l-9.29-.02ZM217.52 42.36l-8.59-15.83s-.37-.64-.84-1.42c.28-.08.59-.15.85-.24a11 11 0 0 0 4.35-2.54 8.73 8.73 0 0 0 2.22-3.74 15.7 15.7 0 0 0 .64-4.48 14.75 14.75 0 0 0-.61-4.25 8 8 0 0 0-2.17-3.5A11.15 11.15 0 0 0 209.05 4a23.4 23.4 0 0 0-7-.88h-12.68v39.24h3.3V25.8h12.05l8.87 16.56h3.93Zm-24.85-19.48V6h9.23a23.38 23.38 0 0 1 5.28.5 8.18 8.18 0 0 1 3.33 1.53 5.48 5.48 0 0 1 1.73 2.57 11.86 11.86 0 0 1 .5 3.64 13.52 13.52 0 0 1-.44 3.59 5.73 5.73 0 0 1-1.65 2.7 8.16 8.16 0 0 1-3.3 1.71 19.6 19.6 0 0 1-5.39.61l-9.29.03ZM443.7 42.36l-8.6-15.83s-.36-.64-.84-1.42c.29-.08.59-.15.86-.24a10.94 10.94 0 0 0 4.34-2.54 8.65 8.65 0 0 0 2.23-3.74 15.7 15.7 0 0 0 .63-4.48 14.75 14.75 0 0 0-.6-4.25 8 8 0 0 0-2.18-3.5A11.1 11.1 0 0 0 435.23 4a23.43 23.43 0 0 0-7-.88h-12.69v39.24h3.3V25.8h12.06l8.86 16.56h3.94Zm-24.86-19.48V6h9.24a23.38 23.38 0 0 1 5.28.5 8.3 8.3 0 0 1 3.33 1.53 5.48 5.48 0 0 1 1.73 2.57 11.88 11.88 0 0 1 .49 3.64 13.12 13.12 0 0 1-.44 3.59 5.58 5.58 0 0 1-1.65 2.7 8 8 0 0 1-3.3 1.71 19.53 19.53 0 0 1-5.38.61l-9.3.03ZM43.41 35.18l15.65-27.1 15.64 27.1h3.88L59.06 1.37 39.53 35.18zM90.76 56.28h-3.88l24.87 43.08H6.36l24.87-43.08h-3.88L.54 102.72h117.03z" }) }) });
var Logo_default = SvgLogo;

// src/components/Payments.tsx
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgPayments = (props) => /* @__PURE__ */ jsxs9(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "26",
    viewBox: "0 0 24 26",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx13("path", { d: "M9 13L2 18.5L9 24V20H21L18 17H9V13Z", fill: "white" }),
      /* @__PURE__ */ jsx13("path", { d: "M15 2L22 7.50019L15 13V9H5L3 6H15V2Z", fill: "#ECC57C" }),
      /* @__PURE__ */ jsx13(
        "path",
        {
          d: "M21 20H9V24L2 18.5L9 13V17H18M3 6.00001H15V1.99982L22 7.50001L15 12.9998V9.00001H5",
          stroke: "black"
        }
      )
    ]
  }
);
var Payments_default = SvgPayments;

// src/components/Support.tsx
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgSupport = (props) => /* @__PURE__ */ jsxs10(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx14(
        "path",
        {
          fill: "#ECC57C",
          stroke: "#000",
          d: "M9.5 10V4c0-.943 0-1.414.293-1.707C10.086 2 10.557 2 11.5 2H20c.943 0 1.414 0 1.707.293C22 2.586 22 3.057 22 4v6c0 .943 0 1.414-.293 1.707C21.414 12 20.943 12 20 12h-8.5c-.943 0-1.414 0-1.707-.293C9.5 11.414 9.5 10.943 9.5 10Z"
        }
      ),
      /* @__PURE__ */ jsx14(
        "path",
        {
          fill: "#fff",
          d: "M17 5.5H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11.5L18 22V6.5a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ jsx14(
        "path",
        {
          stroke: "#000",
          d: "M8.25 10.79c-.312-1.33.345-2.407 1.762-2.407 1.52 0 1.952.999 1.987 1.976.058 1.612-1.914 2.004-1.987 3.645v.396m.488 1.267h-1M18 22V6.5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11.5L18 22Z"
        }
      )
    ]
  }
);
var Support_default = SvgSupport;

// src/components/Team.tsx
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgTeam = (props) => /* @__PURE__ */ jsxs11(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx15(
        "path",
        {
          d: "M5.78867 17.2942L1.57735 10L5.78867 2.70578H14.2113L18.4227 10L14.2113 17.2942H5.78867ZM10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.6193 11.3807 7.50001 10 7.50001C8.61929 7.50001 7.5 8.6193 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
          fill: "white",
          stroke: "black"
        }
      ),
      /* @__PURE__ */ jsx15(
        "path",
        {
          d: "M18.2887 21.9641L16.5774 19L18.2887 16.0359H21.7113L23.4226 19L21.7113 21.9641H18.2887Z",
          fill: "#ECC57C",
          stroke: "black"
        }
      ),
      /* @__PURE__ */ jsx15("circle", { cx: "20", cy: "19", r: "0.5", stroke: "black" })
    ]
  }
);
var Team_default = SvgTeam;

// src/components/Account.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var SvgAccount2 = (props) => /* @__PURE__ */ jsx16(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx16(
      "path",
      {
        fill: "#9E9E9E",
        d: "M10 0H2C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6Zm2 16H4v-2h8v2Zm0-4H4v-2h8v2ZM9 7V1.5L14.5 7H9Z"
      }
    )
  }
);
var Account_default = SvgAccount2;

// src/components/Ach.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgAch = (props) => /* @__PURE__ */ jsx17(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx17(
      "path",
      {
        fill: "#9E9E9E",
        d: "M7.239 17.929h1.768L6.622 6.083H4.369L2 17.93H3.77l.55-3.153h2.37l.55 3.153Zm-2.686-4.505.7-3.97c.084-.584.15-1.135.217-1.752h.05c.067.617.134 1.168.234 1.752l.7 3.97H4.554ZM12.051 18.213c1.919 0 3.07-1.102 3.07-3.154v-1.251l-1.802-.4v1.668c0 1.084-.434 1.668-1.251 1.668-.884 0-1.368-.7-1.368-2.052V9.137c0-1.352.467-1.886 1.351-1.886.851 0 1.251.584 1.251 1.769v1.351l1.819-.384V8.953c0-2.169-1.085-3.153-3.037-3.153-2.052 0-3.203 1.218-3.203 3.52v5.189c0 2.469 1.135 3.704 3.17 3.704ZM22 6.083h-1.752v5.089H17.58V6.083h-1.752V17.93h1.752V12.54h2.67v5.389H22V6.083Z"
      }
    )
  }
);
var Ach_default = SvgAch;

// src/components/AdminPanelSettings.tsx
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgAdminPanelSettings = (props) => /* @__PURE__ */ jsxs12(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx18(
        "path",
        {
          fill: "#9E9E9E",
          d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6Z"
        }
      ),
      /* @__PURE__ */ jsx18(
        "path",
        {
          fill: "#9E9E9E",
          d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 1.38c.62 0 1.12.51 1.12 1.12 0 .61-.51 1.12-1.12 1.12-.61 0-1.12-.51-1.12-1.12 0-.61.5-1.12 1.12-1.12Zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08.73 0 2.19.36 2.24 1.08-.5.71-1.31 1.17-2.24 1.17Z"
        }
      )
    ]
  }
);
var AdminPanelSettings_default = SvgAdminPanelSettings;

// src/components/ApiCircle.tsx
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgApiCircle = (props) => /* @__PURE__ */ jsxs13(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx19("circle", { cx: 17, cy: 17, r: 17, fill: "#000", fillOpacity: 0.04 }),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#000",
          fillRule: "evenodd",
          d: "M9.4 9.4h15.2v15.2H9.4V9.4Zm-2 0a2 2 0 0 1 2-2h15.2a2 2 0 0 1 2 2v15.2a2 2 0 0 1-2 2H9.4a2 2 0 0 1-2-2V9.4Zm4.07 3.484 2.915 3.109-2.867 2.676 1.365 1.462 4.332-4.044-4.285-4.57-1.46 1.367Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var ApiCircle_default = SvgApiCircle;

// src/components/Api.tsx
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgApi = (props) => /* @__PURE__ */ jsxs14("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props, children: [
  /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.6 4.4H4.4v15.2h15.2V4.4Zm-15.2-2a2 2 0 0 0-2 2v15.2a2 2 0 0 0 2 2h15.2a2 2 0 0 0 2-2V4.4a2 2 0 0 0-2-2H4.4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.385 10.993 6.471 7.884 7.93 6.516l4.285 4.571-4.332 4.044-1.365-1.462 2.867-2.676Z",
      clipRule: "evenodd"
    }
  )
] });
var Api_default = SvgApi;

// src/components/BalanceCompliance.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var SvgBalanceCompliance = (props) => /* @__PURE__ */ jsx21("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props, children: /* @__PURE__ */ jsx21("path", { d: "M2 21v-2h9V7.825A2.92 2.92 0 0 1 9.175 6H6l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S2 13.833 2 13l3-7H3V4h6.175c.2-.583.558-1.063 1.075-1.438A2.908 2.908 0 0 1 12 2c.65 0 1.233.187 1.75.562.517.375.875.855 1.075 1.438H21v2h-2l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S15 13.833 15 13l3-7h-3.175A2.918 2.918 0 0 1 13 7.825V19h9v2H2Zm14.625-8h3.75L18.5 8.65 16.625 13Zm-13 0h3.75L5.5 8.65 3.625 13ZM12 6a.97.97 0 0 0 .713-.287A.97.97 0 0 0 13 5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 4a.967.967 0 0 0-.712.287A.968.968 0 0 0 11 5c0 .283.096.521.288.713A.967.967 0 0 0 12 6Z" }) });
var BalanceCompliance_default = SvgBalanceCompliance;

// src/components/Balance.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var SvgBalance = (props) => /* @__PURE__ */ jsx22(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx22(
      "path",
      {
        fill: "#9E9E9E",
        fillRule: "evenodd",
        d: "M17.272 14.045a3.362 3.362 0 0 0 3.36 3.37A3.369 3.369 0 0 0 24 14.044h-.56l-2.528-7.403h-7.424a1.498 1.498 0 0 0-1.04-1.04V3h-.8v2.601a1.512 1.512 0 0 0-1.04 1.04H3.232L.696 14.046H0a3.369 3.369 0 1 0 6.736 0h-.624L4.064 7.442h6.544c.144.504.536.896 1.04 1.04V21.2H8.264v.8h7.744v-.8h-3.56V8.482a1.498 1.498 0 0 0 1.04-1.04h6.592l-2.048 6.603h-.76Zm-5.92-6.989c0-.392.332-.71.742-.71.409 0 .741.318.741.71 0 .392-.332.71-.741.71-.41 0-.742-.318-.742-.71Zm-9.808 7h3.739L3.51 8.33l-1.966 5.726Zm21.142 0h-3.814l1.813-5.726 2.002 5.726Z",
        clipRule: "evenodd"
      }
    )
  }
);
var Balance_default = SvgBalance;

// src/components/BalancingWire.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgBalancingWire = (props) => /* @__PURE__ */ jsx23(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx23(
      "path",
      {
        fill: "#9E9E9E",
        d: "M4 20v-2h2.725A7.85 7.85 0 0 1 4 12c0-1.867.567-3.512 1.7-4.938C6.833 5.638 8.267 4.7 10 4.25v2.1c-1.167.417-2.125 1.138-2.875 2.162C6.375 9.537 6 10.7 6 12c0 .9.18 1.73.537 2.488A6.083 6.083 0 0 0 8 16.45V14h2v6H4Zm11 0a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 12 17c0-.8.275-1.488.825-2.063a2.868 2.868 0 0 1 2.025-.912 3.57 3.57 0 0 1 1.263-1.463A3.308 3.308 0 0 1 18 12c.883 0 1.646.287 2.288.863A3.523 3.523 0 0 1 21.45 15c.7 0 1.3.242 1.8.725s.75 1.067.75 1.75c0 .7-.242 1.296-.725 1.787A2.393 2.393 0 0 1 21.5 20H15Zm2.9-9a5.749 5.749 0 0 0-.675-1.9A6.531 6.531 0 0 0 16 7.55V10h-2V4h6v2h-2.725a8.03 8.03 0 0 1 2.65 5H17.9ZM15 18h6.5a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.35-.15h-1.75v-1.25c0-.483-.17-.896-.512-1.238A1.686 1.686 0 0 0 18 14c-.483 0-.896.17-1.238.512a1.686 1.686 0 0 0-.512 1.238V16H15a.968.968 0 0 0-.713.288A.968.968 0 0 0 14 17c0 .283.096.52.287.712.192.192.43.288.713.288Z"
      }
    )
  }
);
var BalancingWire_default = SvgBalancingWire;

// src/components/Bank.tsx
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgBank = (props) => /* @__PURE__ */ jsxs15(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx24(
        "mask",
        {
          id: "bank_svg__a",
          width: 24,
          height: 24,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ jsx24("path", { fill: "#D9D9D9", d: "M0 0h24v24H0z" })
        }
      ),
      /* @__PURE__ */ jsx24("g", { mask: "url(#bank_svg__a)", children: /* @__PURE__ */ jsx24(
        "path",
        {
          fill: "#000",
          d: "M5 17V8h2v9H5Zm6 0V8h2v9h-2Zm-9 4v-2h20v2H2Zm15-4V8h2v9h-2ZM2 8V6l10-5 10 5v2H2Zm4.45-2h11.1L12 3.25 6.45 6Z"
        }
      ) })
    ]
  }
);
var Bank_default = SvgBank;

// src/components/Book.tsx
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgBook = (props) => /* @__PURE__ */ jsxs16(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#9E9E9E",
          d: "M18 2H6c-1.1 0-2 .9-2 2v10h2V4h12v10h2V4c0-1.1-.9-2-2-2ZM4 19.5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2H7.125c-1.5 0-1.5-2 0-2H20V14h-2v1.5H6V14H4v5.5Z"
        }
      ),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#9E9E9E",
          d: "M13 13v1.5l3-2.5-3-2.5V11H8v1a1 1 0 0 0 1 1h4ZM11 6.5V5L8 7.5l3 2.5V8.5h5v-1a1 1 0 0 0-1-1h-4Z"
        }
      )
    ]
  }
);
var Book_default = SvgBook;

// src/components/CheckIssuing.tsx
import { jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var SvgCheckIssuing = (props) => /* @__PURE__ */ jsxs17(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx26(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.38,
          fillRule: "evenodd",
          d: "M10 10H6V8h4v2ZM15 14H6v-2h9v2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx26(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.38,
          d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V6h16v7h1.994L22 6Z"
        }
      ),
      /* @__PURE__ */ jsx26(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.38,
          fillRule: "evenodd",
          d: "M18 10h-2V8h2v2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx26(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.38,
          d: "M17.6 21.6 19 23l4-4-4-4-1.425 1.4 1.6 1.6H15v2h4.175L17.6 21.6Z"
        }
      )
    ]
  }
);
var CheckIssuing_default = SvgCheckIssuing;

// src/components/CheckDeposit.tsx
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var SvgCheckDeposit = (props) => /* @__PURE__ */ jsxs18(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: props.fill,
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ jsx27(
        "path",
        {
          fillRule: "evenodd",
          d: "M11 11H7V9h4v2zM16 15H7v-2h9v2zM17 11h-2V9h2v2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx27(
        "path",
        {
          fillRule: "evenodd",
          d: "M21 7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7zm-2 0H5v10h14V7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx27("path", { d: "M2 3v3H0V1h5v2H2zM2 21h3v2H0v-5h2v3zM22 3h-3V1h5v5h-2V3zM22 21v-3h2v5h-5v-2h3z" })
    ]
  }
);
var CheckDeposit_default = SvgCheckDeposit;

// src/components/ContentCopy.tsx
import { jsx as jsx28, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgContentCopy = (props) => /* @__PURE__ */ jsxs19("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props, children: [
  /* @__PURE__ */ jsx28("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ jsx28("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })
] });
var ContentCopy_default = SvgContentCopy;

// src/components/Docs.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var SvgDocs = (props) => /* @__PURE__ */ jsx29(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx29("path", { d: "M3 4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3.86a4 4 0 0 1 3.327 1.781l.516.774a1 1 0 0 0 .832.445h.93a1 1 0 0 0 .832-.445l.515-.774A4 4 0 0 1 17.142 17H21a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4a4 4 0 0 0-4 4v9a1 1 0 1 1-2 0V8a4 4 0 0 0-4-4H3Z" })
  }
);
var Docs_default = SvgDocs;

// src/components/DollarCircle.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var SvgDollarCircle = (props) => /* @__PURE__ */ jsx30(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx30(
      "path",
      {
        fill: "#9E9E9E",
        fillRule: "evenodd",
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1.165 16.878v-1.665c1.517-.287 2.711-1.159 2.72-2.754 0-2.197-1.883-2.955-3.644-3.408-1.76-.454-2.327-.933-2.327-1.665 0-.837.784-1.43 2.092-1.43 1.377 0 1.891.663 1.935 1.63h1.708c-.052-1.334-.863-2.563-2.484-2.955v-1.7h-2.327v1.683c-1.5.322-2.711 1.299-2.711 2.798 0 1.787 1.482 2.676 3.643 3.199 1.944.462 2.328 1.142 2.328 1.865 0 .532-.384 1.386-2.092 1.386-1.595 0-2.223-.714-2.31-1.63H7.987c.096 1.691 1.36 2.65 2.85 2.964v1.682h2.328Z",
        clipRule: "evenodd"
      }
    )
  }
);
var DollarCircle_default = SvgDollarCircle;

// src/components/Dollar.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var SvgDollar = (props) => /* @__PURE__ */ jsx31(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx31("path", { d: "M15.568 8.677H18c0-2.474-2.108-4.483-4.703-4.483V1.875h-2.432v2.319c-2.595 0-4.703 2.01-4.703 4.483s2.108 4.482 4.703 4.482v4.483c-1.297 0-2.433-1.082-2.433-2.319H6c0 2.474 2.108 4.483 4.703 4.483v2.319h2.594v-2.319c2.595 0 4.703-2.01 4.703-4.483s-2.108-4.482-4.703-4.482V6.358c1.298.154 2.27 1.082 2.27 2.319Zm-4.703 2.318c-1.297 0-2.433-1.082-2.433-2.318 0-1.237 1.136-2.32 2.433-2.32v4.638Zm4.703 4.483c0 1.237-1.136 2.319-2.433 2.319v-4.483c1.46 0 2.433.927 2.433 2.164Z" })
  }
);
var Dollar_default = SvgDollar;

// src/components/Exit.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var SvgExit = (props) => /* @__PURE__ */ jsx32(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx32("path", { d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59ZM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z" })
  }
);
var Exit_default = SvgExit;

// src/components/Graph.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var SvgGraph = (props) => /* @__PURE__ */ jsx33(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx33("path", { d: "M7.5 21H2V9h5.5v12Zm7.25-18h-5.5v18h5.5V3ZM22 11h-5.5v10H22V11Z" })
  }
);
var Graph_default = SvgGraph;

// src/components/GuidesCircle.tsx
import { jsx as jsx34, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgGuidesCircle = (props) => /* @__PURE__ */ jsxs20(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx34("circle", { cx: 17, cy: 17, r: 17, fill: "#000", fillOpacity: 0.04 }),
      /* @__PURE__ */ jsx34(
        "path",
        {
          fill: "#000",
          d: "M8 9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3.86a4 4 0 0 1 3.328 1.781l.515.774a1 1 0 0 0 .832.445h.93a1 1 0 0 0 .832-.445l.515-.774A4 4 0 0 1 22.142 22H26a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-4a4 4 0 0 0-4 4v9a1 1 0 1 1-2 0v-9a4 4 0 0 0-4-4H8Z"
        }
      )
    ]
  }
);
var GuidesCircle_default = SvgGuidesCircle;

// src/components/Help.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var SvgHelp = (props) => /* @__PURE__ */ jsx35(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx35("path", { d: "M11 18h2v-2h-2v2Zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4Z" })
  }
);
var Help_default = SvgHelp;

// src/components/HideContent.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var SvgHideContent = (props) => /* @__PURE__ */ jsx36(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx36(
      "path",
      {
        fill: "#9E9E9E",
        d: "M10 6.333c2.3 0 4.167 1.867 4.167 4.167 0 .542-.108 1.05-.3 1.525l2.434 2.433a9.848 9.848 0 0 0 2.858-3.958c-1.442-3.658-5-6.25-9.167-6.25a9.704 9.704 0 0 0-3.316.583l1.8 1.8c.475-.191.983-.3 1.525-.3ZM1.668 4.058l1.9 1.9.384.384A9.837 9.837 0 0 0 .834 10.5c1.442 3.658 5 6.25 9.167 6.25 1.291 0 2.525-.25 3.65-.7l.35.35 2.441 2.433 1.059-1.058L2.726 3 1.667 4.058Zm4.609 4.609 1.291 1.291a2.35 2.35 0 0 0-.066.542c0 1.383 1.116 2.5 2.5 2.5.183 0 .366-.025.541-.067l1.292 1.292a4.13 4.13 0 0 1-1.833.442A4.168 4.168 0 0 1 5.834 10.5c0-.658.167-1.275.442-1.833Zm3.591-.65 2.625 2.625.017-.134c0-1.383-1.117-2.5-2.5-2.5l-.142.009Z"
      }
    )
  }
);
var HideContent_default = SvgHideContent;

// src/components/Keys.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var SvgKeys = (props) => /* @__PURE__ */ jsx37(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx37(
      "path",
      {
        d: "M7.31 7.09a.982.982 0 1 0-.001 1.964.982.982 0 0 0 0-1.963Zm5.89-2.454v1.878a6.924 6.924 0 0 0-1.99-2.129 1.471 1.471 0 0 0-2.92.251v.59a4.905 4.905 0 0 1 .982 9.305v6.305L7.31 22.8l-1.964-1.964.982-.981-.982-.982.982-.982-.982-.982v-2.378a4.907 4.907 0 0 1 .982-9.305v-.59A3.44 3.44 0 0 1 9.764 1.2 3.44 3.44 0 0 1 13.2 4.636Zm8.836 14.237v2.945h-2.945v-1.963h-1.964V17.89h-1.963l-1.285-1.286c-.85.305-1.766.369-2.643.195v-1.129a6.87 6.87 0 0 0 2.946-5.635c0-.967-.203-1.887-.566-2.722a4.783 4.783 0 0 1 2.074 1.215 4.897 4.897 0 0 1 1.134 5.13l5.212 5.214Z",
        clipRule: "evenodd"
      }
    )
  }
);
var Keys_default = SvgKeys;

// src/components/NetworkTransfer.tsx
import { jsx as jsx38, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgNetworkTransfer = (props) => /* @__PURE__ */ jsxs21(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#9E9E9E",
          d: "M2.612 17.425C3.688 18.475 4.983 19 6.5 19h3v2l3.5-3-3.5-3v2h-3a3.372 3.372 0 0 1-2.475-1.025A3.372 3.372 0 0 1 3 13.5c0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 6.5 10H7c0-1.383.487-2.563 1.463-3.537C9.438 5.487 10.617 5 12 5s2.563.487 3.537 1.463c.602.601 1.018 1.28 1.248 2.037h2.07c-.267-1.313-.897-2.467-1.893-3.463C15.604 3.68 13.95 3 12 3c-1.583 0-3 .475-4.25 1.425-1.25.95-2.083 2.192-2.5 3.725-1.267.283-2.292.933-3.075 1.95A5.542 5.542 0 0 0 1 13.575c0 1.517.538 2.8 1.612 3.85Z"
        }
      ),
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#9E9E9E",
          d: "M21.863 11.488C21.104 10.629 20.15 10.133 19 10h-5V8l-3.5 3 3.5 3v-2h4.5c.7 0 1.292.242 1.775.725.483.483.725 1.075.725 1.775s-.242 1.292-.725 1.775c-.483.483-1.075.725-1.775.725H14v2h4.5c1.25 0 2.313-.438 3.188-1.313S23 15.75 23 14.5c0-1.15-.38-2.154-1.137-3.012Z"
        }
      )
    ]
  }
);
var NetworkTransfer_default = SvgNetworkTransfer;

// src/components/People.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var SvgPeople = (props) => /* @__PURE__ */ jsx39(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx39("path", { d: "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93Zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36-1.3 0-2.36-1.06-2.36-2.36 0-1.31 1.05-2.36 2.36-2.36Zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68ZM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09Z" })
  }
);
var People_default = SvgPeople;

// src/components/ReceiveMoney.tsx
import { jsx as jsx40, jsxs as jsxs22 } from "react/jsx-runtime";
var SvgReceiveMoney = (props) => /* @__PURE__ */ jsxs22(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx40(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.26,
          d: "m9 20 1.41-1.41L4.83 13H17v-2H4.83l5.58-5.59L9 4l-8 8 8 8ZM34 11h13v2H34z"
        }
      ),
      /* @__PURE__ */ jsx40(
        "path",
        {
          fill: "#000",
          d: "M25 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10S30.52 2 25 2Zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H27.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16Z"
        }
      )
    ]
  }
);
var ReceiveMoney_default = SvgReceiveMoney;

// src/components/ReturnArrow.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var SvgReturnArrow = (props) => /* @__PURE__ */ jsx41(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx41("path", { d: "M19 10.5c0 3.58-2.92 6.5-6.5 6.5H9v2.993L4.5 16 9 12v3h3.5c2.48 0 4.5-2.02 4.5-4.5S14.98 6 12.5 6H7V4h5.5c3.58 0 6.5 2.92 6.5 6.5Z" })
  }
);
var ReturnArrow_default = SvgReturnArrow;

// src/components/SendMoney.tsx
import { jsx as jsx42, jsxs as jsxs23 } from "react/jsx-runtime";
var SvgSendMoney = (props) => /* @__PURE__ */ jsxs23(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.26,
          d: "m39 4-1.41 1.41L43.17 11H31v2h12.17l-5.58 5.59L39 20l8-8-8-8ZM1 11h13v2H1z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#000",
          d: "M23 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10S28.52 2 23 2Zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H25.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16Z"
        }
      )
    ]
  }
);
var SendMoney_default = SvgSendMoney;

// src/components/ShieldBlock.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var SvgShieldBlock = (props) => /* @__PURE__ */ jsx43(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx43("path", { d: "m12 4.14 6 2.25v4.7c0 1.19-.23 2.36-.64 3.44l1.51 1.51c.72-1.53 1.13-3.22 1.13-4.95V5l-8-3-5.22 1.96 1.55 1.55L12 4.14ZM2.81 2.81 1.39 4.22 4 6.83v4.26c0 5.05 3.41 9.76 8 10.91 1.72-.43 3.28-1.36 4.55-2.62l3.23 3.23 1.41-1.41L2.81 2.81ZM12 19.92c-3.45-1.13-6-4.82-6-8.83V8.83l9.14 9.14c-.9.88-1.97 1.57-3.14 1.95Z" })
  }
);
var ShieldBlock_default = SvgShieldBlock;

// src/components/ShieldOutline.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var SvgShieldOutline = (props) => /* @__PURE__ */ jsx44(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx44("path", { d: "M12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3Zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12 6 2.12v4.78Zm-9.18-.5L7.4 12l3.54 3.54 5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12Z" })
  }
);
var ShieldOutline_default = SvgShieldOutline;

// src/components/Shield.tsx
import { jsx as jsx45, jsxs as jsxs24 } from "react/jsx-runtime";
var SvgShield = (props) => /* @__PURE__ */ jsxs24(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx45(
        "path",
        {
          fill: "#713EC4",
          d: "M14.167 9.167c.283 0 .558.033.833.075V5.225L8.75 2.5 2.5 5.225v4.092c0 3.783 2.667 7.325 6.25 8.183a7.64 7.64 0 0 0 1.333-.458 4.982 4.982 0 0 1-.916-2.875c0-2.759 2.241-5 5-5Z"
        }
      ),
      /* @__PURE__ */ jsx45(
        "path",
        {
          fill: "#713EC4",
          d: "M14.167 10.833a3.332 3.332 0 1 0 0 6.667 3.332 3.332 0 1 0 0-6.667Zm0 1.15c.516 0 .933.425.933.934a.943.943 0 0 1-.933.933.943.943 0 0 1-.934-.933c0-.509.417-.934.934-.934Zm0 4.475a2.27 2.27 0 0 1-1.867-.975c.042-.6 1.258-.9 1.867-.9.608 0 1.825.3 1.866.9a2.27 2.27 0 0 1-1.866.975Z"
        }
      )
    ]
  }
);
var Shield_default = SvgShield;

// src/components/ShowContent.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var SvgShowContent = (props) => /* @__PURE__ */ jsx46(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx46(
      "path",
      {
        fill: "#9E9E9E",
        d: "M10 4.25c-4.167 0-7.725 2.592-9.167 6.25 1.442 3.658 5 6.25 9.167 6.25s7.725-2.592 9.167-6.25c-1.442-3.658-5-6.25-9.167-6.25Zm0 10.417A4.168 4.168 0 0 1 5.833 10.5C5.833 8.2 7.7 6.333 10 6.333S14.167 8.2 14.167 10.5 12.3 14.667 10 14.667ZM10 8a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5S11.383 8 10 8Z"
      }
    )
  }
);
var ShowContent_default = SvgShowContent;

// src/components/SignIn.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var SvgSignIn = (props) => /* @__PURE__ */ jsx47(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx47("path", { d: "M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5Zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14Z" })
  }
);
var SignIn_default = SvgSignIn;

// src/components/Union.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var SvgUnion = (props) => /* @__PURE__ */ jsx48(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx48(
      "path",
      {
        fill: "#9E9E9E",
        fillRule: "evenodd",
        d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm1.917 1a6.002 6.002 0 0 1-11.834 0H2v-2h4.083a6.002 6.002 0 0 1 11.834 0H22v2h-4.083Z",
        clipRule: "evenodd"
      }
    )
  }
);
var Union_default = SvgUnion;

// src/components/Wire.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var SvgWire = (props) => /* @__PURE__ */ jsx49(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx49(
      "path",
      {
        fill: "#9E9E9E",
        d: "M13.299 12.25a1.5 1.5 0 1 1-2.598-1.5 1.5 1.5 0 0 1 2.598 1.5ZM21.312 9.37l2.165 1.25-1.03-5.213-5.032 1.714 2.165 1.25L16.33 14c-.253.439-.63.65-.906.658-.196.005-.682-.09-1.205-1.114l-.004-.007-.106-.201a2.785 2.785 0 0 1-1.766.939l.099.186c.731 1.428 1.802 2.23 3.037 2.196 1.156-.031 2.087-.797 2.583-1.657l3.25-5.63ZM6.585 15.88 4.42 14.63 7.67 9c.253-.439.63-.65.906-.658.196-.005.682.09 1.205 1.114l.004.007.107.201a2.784 2.784 0 0 1 1.766-.939l-.1-.186c-.73-1.428-1.802-2.23-3.036-2.196-1.157.03-2.087.797-2.584 1.657l-3.25 5.63-2.165-1.25 1.03 5.213 5.032-1.714Z"
      }
    )
  }
);
var Wire_default = SvgWire;
export {
  Account_default as Account,
  Accounts_default as Accounts,
  Ach_default as Ach,
  AdminPanelSettings_default as AdminPanelSettings,
  Api_default as Api,
  ApiCircle_default as ApiCircle,
  ApiDeveloper_default as ApiDeveloper,
  ApiDocs_default as ApiDocs,
  ApiReference_default as ApiReference,
  Balance_default as Balance,
  BalanceCompliance_default as BalanceCompliance,
  BalancingWire_default as BalancingWire,
  Bank_default as Bank,
  Book_default as Book,
  CheckDeposit_default as CheckDeposit,
  CheckIssuing_default as CheckIssuing,
  Compliance_default as Compliance,
  ContentCopy_default as ContentCopy,
  Docs_default as Docs,
  Dollar_default as Dollar,
  DollarCircle_default as DollarCircle,
  Entities_default as Entities,
  Error_default as Error,
  Exit_default as Exit,
  Feedback_default as Feedback,
  Graph_default as Graph,
  Guides_default as Guides,
  GuidesCircle_default as GuidesCircle,
  Help_default as Help,
  HideContent_default as HideContent,
  Home_default as Home,
  Keys_default as Keys,
  Lock_default as Lock,
  Logo_default as Logo,
  NetworkTransfer_default as NetworkTransfer,
  Payments_default as Payments,
  People_default as People,
  ReceiveMoney_default as ReceiveMoney,
  ReturnArrow_default as ReturnArrow,
  SendMoney_default as SendMoney,
  Shield_default as Shield,
  ShieldBlock_default as ShieldBlock,
  ShieldOutline_default as ShieldOutline,
  ShowContent_default as ShowContent,
  SignIn_default as SignIn,
  Support_default as Support,
  Team_default as Team,
  Union_default as Union,
  Wire_default as Wire
};
